import React, { FocusEvent } from 'react';
import { Control, useController, UseControllerProps } from 'react-hook-form';
import { memoizeField } from '../memoizeField';
import './PhoneNumber.styles.scss';
import FieldWrapper, { FormMethods } from '../FieldWrapper';
import PhoneInput, { CountryData, PhoneInputProps } from 'react-phone-input-2';

type Props = {
  name: string;
  control?: Control;
  id?: string;
  required?: boolean
  controllerProps?: UseControllerProps
} & FormMethods & PhoneInputProps

function PhoneField(props: Props) {
  const {
    name,
    control,
    controllerProps,
    formMethods,
    onBlur = () => {
    },
    ...rest
  } = props;

  const { field } = useController({
    name,
    control: formMethods?.control || control,
    rules: controllerProps?.rules,
    defaultValue: controllerProps?.defaultValue,
    shouldUnregister: controllerProps?.shouldUnregister,
  });

  const handleBlur = (event: FocusEvent<HTMLInputElement>, countryData: CountryData) => {
    onBlur(event, countryData);

    if (field.onBlur) {
      field.onBlur();
    }
  };

  return (
    <PhoneInput
      onBlur={handleBlur}
      country="us"
      value={field.value}
      onChange={field.onChange}
      specialLabel={props.specialLabel}
      inputClass="phoneNumberInput"
      containerClass="phoneNumberContainer"
      inputProps={{
        id: props.id,
        required: props.required,
      }}
      {...rest}
    />
  );
}

export default FieldWrapper(memoizeField(PhoneField));
